import { render, staticRenderFns } from "./survey_question.vue?vue&type=template&id=4ba8780f&"
import script from "./survey_question.vue?vue&type=script&lang=js&"
export * from "./survey_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba8780f')) {
      api.createRecord('4ba8780f', component.options)
    } else {
      api.reload('4ba8780f', component.options)
    }
    module.hot.accept("./survey_question.vue?vue&type=template&id=4ba8780f&", function () {
      api.rerender('4ba8780f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/survey_question.vue"
export default component.exports